/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ILdsUnitHistoryTileViewProps } from './lds-unit-history-tile';

export default (props: ILdsUnitHistoryTileViewProps) => {
    const header = props.config.heading && props.config.heading.text ? props.config.heading.text : 'Unit Order History';
    const pageLink =
        props.config.unitOrderLink && props.config.unitOrderLink.linkUrl ? props.config.unitOrderLink.linkUrl.destinationUrl : '';
    let isVisible = [];
    if (props.data.paymentTypes && props.data.paymentTypes.result) {
        isVisible = props.data.paymentTypes.result.filter(payment => {
            return payment.ACCOUNTNUM !== '';
        });
    }
    if (isVisible.length !== 0) {
        return (
            <div className='ms-account-generic-tile'>
                <h2 className='ms-account-generic-tile__heading'>{header}</h2>
                <div className='ms-account-generic-tile__links'>
                    <a className='ms-account-generic-tile__link' href={pageLink}>
                        {props.resources.pageLink}
                    </a>
                </div>
            </div>
        );
    } else {
        return <div></div>;
    }
};
